//
//
//
//
//
//
//
//
//
//
//
//

import tabSelect from '@/components/clinic/tabSelect.vue'
import doctorCard from '@/components/clinic/doctorCard.vue'
import infiniteLoading from 'vue-infinite-loading'
import oasis from '../../lib/api.oasis'
export default {
  data(){
    return{
      doctorList: [],
      pagenum: 1
    }
  },
  components: {
    tabSelect,
    doctorCard,
    infiniteLoading
  },
  methods: {
    getClinicList($state){
      var pagesize=10
      var infos= {
        "latitude":"39.91511",
        "longitude":"116.40396",
        "pagenum": this.pagenum,
        "pagesize":"10"
      }
      oasis.postDoctorList(infos).then(response => {
        console.log(response,'-----------------------')
        if(response.datalist&&response.datalist.length){
          this.doctorList = this.doctorList.concat(response.datalist)
          $state.loaded()
          this.pagenum++
          if (response.datalist.length < infos.pagesize) {
            $state.complete()
          }
        }else{
          $state.complete();
        }
      }).catch(err=>{
        console.log(err,'errCatch');
      })
    }
  },
  mounted () {
    // this.getClinicList()
  }
}



// WEBPACK FOOTER //
// ./src/views/clinic/clinicDoctor.vue